const KEY = ['CONTENTS_FILE_SERVICE'];

export { KEY };
